// Shared booking date/time math for the dashboard + calendar views.
// Replaces four copy-pasted `addMinutes` helpers (NewDashboard1, Dashboard,
// NewDashboard, CalendarPage) that added minutes to today's Date and returned
// only the "HH:mm" clock part. That wrapped at midnight, so a job running past
// 24:00 (e.g. 15:00 + 9h15m) ended at "00:15" on its own service date - i.e.
// before it started - and the Crew Utilization total went negative.

const pad = (n) => String(n).padStart(2, "0");

/**
 * Returns the local, timezone-less "YYYY-MM-DDTHH:mm:00" string `minutesToAdd`
 * after `dateStr` + `timeStr`, rolling over into the next day(s) when needed.
 * Same string shape FullCalendar and `new Date(...)` already get for `start`.
 *
 * Returns null when the date/time can't be parsed. A non-numeric or negative
 * duration is treated as zero, so the end never lands before the start.
 */
export const addMinutesToDateTime = (dateStr, timeStr, minutesToAdd) => {
  const [y, m, d] = String(dateStr || "").slice(0, 10).split("-").map(Number);
  const [hh, mm] = String(timeStr || "").split(":").map(Number);
  if (![y, m, d, hh, mm].every(Number.isFinite)) return null;

  const mins = Math.max(0, Math.trunc(Number(minutesToAdd) || 0));
  // UTC is used purely as a calendar calculator (no DST jumps); the result is
  // formatted back out without a zone designator.
  const t = new Date(Date.UTC(y, m - 1, d, hh, mm + mins));
  return (
    `${t.getUTCFullYear()}-${pad(t.getUTCMonth() + 1)}-${pad(t.getUTCDate())}` +
    `T${pad(t.getUTCHours())}:${pad(t.getUTCMinutes())}:00`
  );
};
